import { render, staticRenderFns } from "./highchart.vue?vue&type=template&id=8a6c70ac&scoped=true&"
import script from "./highchart.vue?vue&type=script&lang=ts&"
export * from "./highchart.vue?vue&type=script&lang=ts&"
import style0 from "./highchart.vue?vue&type=style&index=0&id=8a6c70ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6c70ac",
  null
  
)

export default component.exports